import { render, staticRenderFns } from "./tagBlock.vue?vue&type=template&id=100dae5c&"
import script from "./tagBlock.vue?vue&type=script&lang=js&"
export * from "./tagBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports